import { combineReducers } from 'redux'
import userGrid from './userGrid'

const userGridReducer = combineReducers({
  userGrid,
})

export default userGridReducer
